import { render, staticRenderFns } from "./PredictionConfigPerformanceTable.vue?vue&type=template&id=e7e17aec&scoped=true&"
import script from "./PredictionConfigPerformanceTable.vue?vue&type=script&lang=js&"
export * from "./PredictionConfigPerformanceTable.vue?vue&type=script&lang=js&"
import style0 from "./PredictionConfigPerformanceTable.vue?vue&type=style&index=0&id=e7e17aec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e17aec",
  null
  
)

export default component.exports